import React, { useState, useEffect, useCallback } from "react";
import { useExamStatus } from "../ExamStatusContext";
import { useScoreTable } from "../ScoreContext";
import withResetOnNavigation from '../withResetOnNavigation';
import TestContainer from "../TestContainer";
import ZoomControls from "../ZoomControls";
import "../../../css/test9.css";
import answer from "../QA/Test9_q_a/answer";
import kensa9_example from "../QA/Test9_q_a/kensa9_example.jpg";

const Test9 = ({ onNext }) => {
  const { examStatus } = useExamStatus();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [inputValues, setInputValues] = useState({});
  const [isTest9Started, setIsTest9Started] = useState(false);
  const [notification, setNotification] = useState("");
  const [isTimeUp, setIsTimeUp] = useState(false);
  const score9 = React.useRef(0);
  const scoreTable = useScoreTable();

  const testDuration = 90;
  const totalQuestions = 28;

  useEffect(() => {
    const test9Status = localStorage.getItem("test9Status");
    if (examStatus === "検査中" && test9Status === "started") {
      localStorage.setItem("test9Status", "notStarted");
    }
  }, [examStatus]);

  const gradeTest = useCallback(() => {
    let calculatedScore = 0;

    for (let i = 0; i < totalQuestions; i++) {
      const userAnswer = inputValues[i + 1];
      const correctAnswer = answer[i + 1];
      if (userAnswer === correctAnswer) {
        calculatedScore += 1;
      }
    }

    score9.current = calculatedScore;
    localStorage.setItem("score9", calculatedScore);

    const [gScore, sScore] = scoreTable.scoreTable9[calculatedScore] || [0, 0];
    const currentGScore = parseInt(localStorage.getItem("G_score"), 10) || 0;
    const currentSScore = parseInt(localStorage.getItem("S_score"), 10) || 0;

    localStorage.setItem("G_score", currentGScore + gScore);
    localStorage.setItem("S_score", currentSScore + sScore);

    setNotification("検査を終了します！");
    setIsTimeUp(true);

    if (onNext) onNext(); // ← 最後の検査終了後の処理（結果ページ遷移など）
  }, [inputValues, scoreTable, onNext]);

  const handleStartTest = () => {
    setIsTest9Started(true);
    localStorage.setItem("test9Status", "started");
  };

  const handleInputChange = (index, value) => {
    setInputValues((prev) => ({
      ...prev,
      [index]: value,
    }));
    if (value !== "-" && index === currentQuestionIndex + 1) {
      setCurrentQuestionIndex(index);
    }
  };

  const getImagePath = (index) =>
    require(`../QA/Test9_q_a/kensa9_${index + 1}.jpg`);

  const renderedQuestions = Array.from({ length: totalQuestions })
    .slice(0, currentQuestionIndex + 1)
    .map((_, index) => (
      <div key={index} className="test9-question">
        <p>問題 {index + 1}</p>
        <img
          src={getImagePath(index)}
          alt={`問題${index + 1}`}
          className="test9-image"
        />
        <select
          value={inputValues[index + 1] || "-"}
          onChange={(e) => handleInputChange(index + 1, e.target.value)}
        >
          <option value="-">-</option>
          <option value="A">A</option>
          <option value="B">B</option>
          <option value="C">C</option>
          <option value="D">D</option>
        </select>
      </div>
    ));

  if (!isTest9Started) {
    return (
      <div className="test9-container">
        <h1>検査7 - やり方の説明</h1>
        <p>
          左の図形を組み立てると右側の4つ（A～D）の立体形のどれかになります。それを答えて下さい。
          <br />
          左の図形で点線のところは立体形を作る時に折り曲げるところですが、点線のない所で丸めることもあります。
        </p>
        <h2>例題</h2>
        <div className="example-container">
          <img
            src={kensa9_example}
            alt="例題9"
            className="test9-image-example"
          />
        </div>
        <button className="start-button" onClick={handleStartTest}>
          検査に進む
        </button>
      </div>
    );
  }

  return (
    <ZoomControls>
      <TestContainer
        title="検査7"
        isTimeUp={isTimeUp}
        notification={notification}
        renderedQuestions={renderedQuestions}
        manageTimer={true}
        gradeTest={gradeTest}
        testDuration={testDuration}
      />
    </ZoomControls>
  );
};

export default withResetOnNavigation(Test9);
